import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from "context/AuthContext";
import { useUser } from "context/UserContext";
import { 
  IconButton
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import './Soporte.css';

import { uuidToConsulta9 } from '../../utils/uuidConverter';
import BottomTabBar from '../../components/BottomTabBar';
import soporteSVG from '../../assets/illustrations/soporte.svg';

const Soporte = () => {
    const { getToken } = useAuth();
    const { profesionalData, email: emailContext } = useUser();
    const [titulo, setTitulo] = useState('');
    const [detalle, setDetalle] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();
    const baseURL = process.env.REACT_APP_BASE_URL || "https://sandbox.payflexapp.com";

    // Debug: Log del estado inicial
    console.log('=== COMPONENTE SOPORTE INICIALIZADO ===');
    console.log('Backend URL:', baseURL);
    console.log('Estado inicial - titulo:', titulo);
    console.log('Estado inicial - detalle:', detalle);
    console.log('Estado inicial - isSubmitting:', isSubmitting);
    console.log('Estado inicial - error:', error);
    console.log('Estado inicial - success:', success);



    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevenir el comportamiento por defecto del formulario
        console.log('=== INICIO handleSubmit ===');
        console.log('Evento:', e);
        console.log('Título:', titulo);
        console.log('Detalle:', detalle);
        const token = await getToken();
        if (!token) {
          setError('No se pudo obtener el token de autenticación');
          navigate("/authentication/sign-in");
          return;
        }
        console.log('Backend URL:', baseURL);
        
        setIsSubmitting(true);
        setError('');
        
        try {
            console.log('=== PASO 1: Usando datos del contexto ===');
            
            // Usar datos del contexto en lugar de hacer otra llamada a la API
            const userData = profesionalData || {};
            const userEmail = emailContext || userData.email;
            console.log('Datos del profesional (desde contexto):', userData);
            console.log('Email del usuario:', userEmail);

            // Debug: mostrar qué campos devuelve el contexto
            console.log('=== PASO 2: Preparando datos para crear reclamo ===');
            console.log('Documento del usuario:', userData.documento);
            console.log('Email del usuario:', userEmail);

            // Debug: mostrar los datos que se van a enviar
            const requestData = {
                titulo,
                detalle,
                documento: userData.documento,
                prioridad: 'media',
                joined: [],
                archivos: []
            };
            console.log('Datos a enviar al backend:', requestData);
            console.log('JSON stringificado:', JSON.stringify(requestData));

            console.log('=== PASO 3: Enviando request a crear-reclamo ===');
            console.log('URL crear-reclamo:', `${baseURL}/crear-reclamo`);
            
            const response = await fetch(`${baseURL}/crear-reclamo`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestData),
            });

            console.log('=== PASO 4: Procesando respuesta ===');
            console.log('Response status:', response.status);
            console.log('Response ok:', response.ok);
            console.log('Response headers:', response.headers);

            if (!response.ok) {
                const errorText = await response.text();
                console.error('=== ERROR DEL BACKEND ===');
                console.error('Status code:', response.status);
                console.error('Error response text:', errorText);
                
                // Intentar parsear como JSON si es posible
                try {
                    const errorData = JSON.parse(errorText);
                    console.error('Error data (parsed):', errorData);
                    throw new Error(errorData.message || 'Error al crear el reclamo');
                } catch (parseError) {
                    console.error('No se pudo parsear la respuesta como JSON');
                    throw new Error(`Error ${response.status}: ${errorText}`);
                }
            }

            const data = await response.json();
            console.log('Respuesta del backend (raw):', data);

            // Debug: mostrar la respuesta del backend
            console.log('=== PASO 5: Respuesta exitosa ===');
            console.log('Respuesta del backend al crear reclamo:', data);
            console.log('Tipo de reclamoId:', typeof data.reclamoId);
            console.log('Valor de reclamoId:', data.reclamoId);

            // Verificar que el ID del reclamo existe
            if (!data.reclamoId) {
                console.error('=== ERROR: ID DEL RECLAMO NO ENCONTRADO ===');
                console.error('ID del reclamo no encontrado en la respuesta:', data);
                console.error('Claves disponibles en la respuesta:', Object.keys(data));
                throw new Error('No se pudo obtener el ID del reclamo');
            }

            // Debug: mostrar el UUID antes de la conversión
            console.log('=== PASO 6: Convirtiendo UUID ===');
            console.log('UUID del reclamo:', data.reclamoId);

            // Convertir el ID del reclamo a número de consulta
            const numeroConsulta = uuidToConsulta9(data.reclamoId);
            
            // Debug: mostrar el número de consulta generado
            console.log('=== PASO 7: Número de consulta generado ===');
            console.log('Número de consulta generado:', numeroConsulta);

            // Enviar el email del usuario y el número de consulta al webhook
            console.log('=== PASO 8: Enviando webhook ===');
            console.log('Email para webhook:', userEmail);
            console.log('Número de consulta para webhook:', numeroConsulta);
            
            try {
                const webhookResponse = await fetch('https://hook.us2.make.com/xxk6nx84o7ndc9twlfvgb8jku5ae5nuy', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        mail: userEmail,
                        numeroConsulta: numeroConsulta
                    }),
                });
                
                console.log('Webhook response status:', webhookResponse.status);
                console.log('Webhook enviado exitosamente');
            } catch (webhookError) {
                console.error('=== ERROR EN WEBHOOK ===');
                console.error('Error al enviar al webhook:', webhookError);
                console.error('Tipo de error:', typeof webhookError);
                console.error('Mensaje de error:', webhookError.message);
                // No lanzamos el error para no afectar la experiencia del usuario
            }

            console.log('=== PASO 9: Finalizando con éxito ===');
            setSuccess(true);
            setTitulo('');
            setDetalle('');
            console.log('Estado actualizado a success: true');
            
            // Eliminamos la redirección automática

        } catch (err) {
            console.error('=== ERROR GENERAL ===');
            console.error('Tipo de error:', typeof err);
            console.error('Mensaje de error:', err.message);
            console.error('Stack trace:', err.stack);
            console.error('Error completo:', err);
            setError(err.message);
        } finally {
            console.log('=== FINALIZANDO ===');
            setIsSubmitting(false);
            console.log('isSubmitting establecido a false');
        }
    };

    return (
        <>
            <div className="SoporteContainer">
                {/* Header */}
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '30px', padding: '20px' }}>
                    <IconButton onClick={() => navigate('/perfil')} sx={{ color: "#000", padding: '8px', marginRight: '16px' }}>
                        <ArrowBackIcon />
                    </IconButton>
                    <h1 style={{ fontWeight: 'bold', color: '#000', fontSize: '20px', margin: 0 }}>Ayuda</h1>
                </div>
                
                <div className="SoporteContent">
                    {/* Ilustración SVG */}
                    <div className="SoporteIllustration">
                        <img src={soporteSVG} alt="Soporte" />
                    </div>
                    
                    <h1 className="SoporteMainTitle">¿Necesitas ayuda? Cuéntanos qué sucede y te responderemos lo antes posible.</h1>

                {success ? (
                    <>
                        <div className="SuccessMessage">
                            <h2>¡Enviado con éxito!</h2>
                            <p>Te contactaremos a la brevedad...</p>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <button 
                                className="VolverButton"
                                onClick={() => navigate('/perfil')}
                            >
                                Volver
                            </button>
                        </div>
                    </>
                ) : (
                    <form onSubmit={handleSubmit} className="SoporteForm">
                        <div className="FormGroup">
                            <label htmlFor="titulo">Duda / consulta</label>
                            <input
                                type="text"
                                id="titulo"
                                value={titulo}
                                onChange={(e) => setTitulo(e.target.value)}
                                placeholder="Describí tu consulta acá..."
                            />
                        </div>

                        <div className="FormGroup">
                            <label htmlFor="detalle">Mensaje</label>
                            <textarea
                                id="detalle"
                                value={detalle}
                                onChange={(e) => setDetalle(e.target.value)}
                                placeholder="Escribí tu mensaje acá..."
                                rows={6}
                            />
                        </div>

                        {error && <div className="ErrorMessage">{error}</div>}

                        <button 
                            type="submit" 
                            className="SubmitButton"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Enviando...' : 'Enviar'}
                        </button>
                    </form>
                )}
                </div>

               
            </div>
            <BottomTabBar />
        </>
    );
};

export default Soporte; 